import React, { Component } from 'react';
import { Field, FieldArray, reset } from 'redux-form'
import ReactDataGrid from 'react-data-grid';
import { Data, CheckboxEditor } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button} from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';

import axios from 'axios';
import {MAG_DRAYAGE_LIST} from '../../actions/url';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from "../../actions/root_url";

const isKDW = ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || ROOT_URL === 'https://kdw-scm.truckxi.com/api/';

class RowRenderer extends Component {

    PropTypes: {
      onDoubleClick: React.PropTypes.func
    };

    render() {
        return (<div onDoubleClick={ ()=>{ this.props.onDoubleClick(this.props.row, this.props.field) } } ><ReactDataGrid.Row ref="row" {...this.props} /></div>)
    }
}

export class DrayageList extends Component {
  constructor() {
    super();
    this.state = {
      measurementUnit: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      }
    }
    this.addDrayageList = this.addDrayageList.bind(this);
    this.editDrayageList = this.editDrayageList.bind(this);
    this.deleteDrayageList = this.deleteDrayageList.bind(this);
  }

  componentWillMount() {
    let { measurementUnit } = this.state;
    measurementUnit = {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      };

    axios.get(
        MAG_DRAYAGE_LIST,
        // this.state.magSalesOrderDetail,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ).then((response) => {
        // console.log("DRAYAGELIST", response);
        measurementUnit.rows = response.data;

        measurementUnit.rows.map((r, index) => {
          r.Idx = index++;
        })
    this.setState({measurementUnit});

      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
        } 
        alert(JSON.stringify(err.data));
      });

  }

  componentWillUnmount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  getDrayageAgain() {
    let { measurementUnit } = this.state;
    measurementUnit = {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      };

    axios.get(
        MAG_DRAYAGE_LIST,
        // this.state.magSalesOrderDetail,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ).then((response) => {
        // console.log("DRAYAGELIST", response);
        measurementUnit.rows = response.data;

      measurementUnit.rows.map((r,index) => {
        r.Idx = index++;
      })

  this.setState({measurementUnit});

      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
        } 
        alert(JSON.stringify(err.data));
      });

  }

  addDrayageList() {
    let rows = [...this.state.measurementUnit.rows]
    if (isKDW) {
      rows.push({id: 0, name: "", address: "", drayage_code: "NA", Idx: rows.length})
    } else {
    rows.push({id: 0, name: "", address: "", drayage_code: "", Idx: rows.length})
    }
    let measurementUnit = { ...this.state.measurementUnit, rows }
    this.setState({measurementUnit})
  }

  editDrayageList() {
    axios.post(
        MAG_DRAYAGE_LIST, this.state.measurementUnit.rows,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
        .then((response) => {
            this.getDrayageAgain();
            alert("List Saved");
        }, (err) => {
        if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
        }
        alert(JSON.stringify(err.data));
        });
  }

  deleteDrayageList(event) {
    event.preventDefault();
    let drayage_id = this.state.measurementUnit.selectedRows[0].id;
    if(drayage_id != 0) {
    axios.delete(
        `${MAG_DRAYAGE_LIST}${drayage_id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
        .then(() => {
          alert("Address Deleted");
          this.getDrayageAgain();
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
              } 
              alert(JSON.stringify(err.data));
        });

      let measurementUnit = {...this.state.measurementUnit, selectedRows: []};
      this.setState({measurementUnit})
    }
    else {
      let rows = [...this.state.measurementUnit.rows];
      let index = _.findIndex(rows, {Idx: this.state.measurementUnit.selectedRows[0].Idx})
      rows.splice(index, 1);
      let measurementUnit = {...this.state.measurementUnit, rows, selectedRows: []};
      this.setState({measurementUnit})
    }
  }

  render() {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.measurementUnit);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var measurementUnit = Object.assign({}, this.state.measurementUnit, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({measurementUnit});
        }

        const handleRowUpdated = e => {
          var rows = getRows();
          Object.assign(rows[e.rowIdx], e.updated);
          let measurementUnit = {...this.state.measurementUnit, rows}
          this.setState({measurementUnit})
        }

        const onRowsSelected = (rows) => {
             let newRows = getRows();
             newRows.map(r => {
               r.isSelected = false;
             })
             rows.map (r => {
               newRows[r.rowIdx].isSelected = true;
             });
             let measurementUnit = {...this.state.measurementUnit, rows: newRows, selectedRows: [rows[0].row]}
             this.setState({measurementUnit});
        }

         const onRowsDeselected = (rows) => {
             let newRows = getRows();
             rows.map (r => {
               newRows[r.rowIdx].isSelected = false;
             });
             let measurementUnit = {...this.state.measurementUnit, rows: newRows, selectedRows: []}
             this.setState({measurementUnit});
         }
        // Column difinition

        let columns = [
          {
              key: 'name',
              name: <Translate value="name"/>,
              resizable: true,
              sortable: true,
              width: 150,
              editable: true,
              // filterRenderer: FilterByStart,
          },
          {
              key: 'address',
              name: <Translate value="address"/>,
              resizable: true,
              sortable: true,
              width: 250,
              editable: true,
              // filterRenderer: FilterByStart,
          },
          {
              key: 'drayage_code',
              name: <Translate value="drayage"/>,
              resizable: true,
              sortable: true,
              width: 130,
              editable: true,
          },
        ];

        if (isKDW) {
          columns = [
            {
                key: 'name',
                name: <Translate value="name"/>,
                resizable: true,
                sortable: true,
                width: 200,
                editable: true,
                // filterRenderer: FilterByStart,
            },
            {
                key: 'address',
                name: <Translate value="address"/>,
                resizable: true,
                sortable: true,
                width: 300,
                editable: true,
                // filterRenderer: FilterByStart,
            },
           
          ]
        }

        return (
          <div>
            <ButtonToolbar>
              <Button onClick={this.addDrayageList} disabled={!checkPermission('add_product_group')}><em className="fa fa-plus"/><Translate value="create"/></Button>
              <Button
                bsStyle="success"
                onClick={this.editDrayageList}
                disabled={!checkPermission('change_product_group')}
              >
                <em className="fa fa-save marginRightStyle" /><Translate value="save"/>
              </Button>
                <Button
                  bsStyle="danger"
                  className="buttonStyle"
                  onClick={(event) => { this.deleteDrayageList(event)}}
                  disabled={!this.state.measurementUnit.selectedRows || this.state.measurementUnit.selectedRows.length != 1 || !checkPermission('delete_product_group')}
                  ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                </Button>
            </ButtonToolbar>
            <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="MeasurementUnit-dataGrid1">
                <ReactDataGrid
                    // rowRenderer={<RowRenderer field={this.props.field}/>}
                    rowKey='MeasurementUnit_id'
                    rowHeight={25}
                    minHeight={620}
                    onGridSort={handleGridSort}
                    enableRowSelect='single'
                    columns={columns}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    enableCellSelect={true}
                    onRowUpdated={handleRowUpdated}
                    rowSelection={{
                      showCheckbox: true,
                      onRowsSelected: onRowsSelected,
                      onRowsDeselected: onRowsDeselected,
                      selectBy: {
                        isSelectedKey: 'isSelected'
                      }
                    }}
                />
            </div></Col></Row>
            <br/>
        </div>
        )
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Products/drayageList.jsx